export * from '@entities/khu-vuc/khu-vuc.module';
export * from '@entities/khu-vuc/khu-vuc.model';
export * from '@entities/khu-vuc/khu-vuc.service';
export * from '@entities/khu-vuc/khu-vuc.route';
export * from '@entities/khu-vuc/khu-vuc/khu-vuc.component';
export * from '@entities/khu-vuc/khu-vuc-dialog/khu-vuc-dialog.component';
export * from '@entities/khu-vuc/khu-vuc-delete-dialog/khu-vuc-delete-dialog.component';
